import React from 'react'

const FooterInfos = () => {
  return (
    <span className="fs-10">
      FLORAJET S.A.S - Réseau Fleuri - 26 chemin de l'Esqueiras 84240 Cabrières-d'Aigues | Téléphone : 0826 107 707 (0.15€ TTC/min) |{' '}
      <a href="https://static.florajet.net/fleuriste/CGV_FLORAJET.pdf" target="_blank" rel="noreferrer">Conditions Générales de Vente - CGV</a>
    </span>
  )
}

export default FooterInfos
